import { Box, Heading, Icon } from '@chakra-ui/react';
import { ChevronRightIcon } from '@heroicons/react/solid';

type Props = {
  thinText?: string;
  boldText: string;
  size?: 'md' | 'lg';
};

export function SectionHeading({
  thinText,
  boldText,
  size = 'md'
}: Props): JSX.Element {
  const headingSize = size === 'md' ? 'h6' : 'h5';

  return (
    <Heading size={headingSize} color="var(--primaryTextColor)">
      {thinText && (
        <>
          <Box as="span" fontWeight="normal">
            {thinText}
          </Box>{' '}
        </>
      )}
      {boldText}
      <Icon
        as={ChevronRightIcon}
        boxSize={5}
        color="var(--secondaryTextColor)"
      />
      <Icon
        as={ChevronRightIcon}
        boxSize={5}
        color="var(--secondaryTextColor)"
        pos="relative"
        left="-14px"
      />
    </Heading>
  );
}
